import React from "react"
import DesktopHeaderContainer from "../../../desktopHeaderContainer"
import ProductsTitle from "../../../productsTitle"
import {SearchBannerChevronContainer} from "./components"
import SearchBannerChevron from "../../../searchBannerChevron"
import FadeInAnimation from "../../../fadeInAnimation"
import {useSearchBannerLoaded} from "../../../../hooks/useSearchBannerLoaded"
import {ChevronWithContext} from "../../../searchBanner/copy/components"

interface Cashmere25ProductsHeaderProps {
    url: string
    enableSearchBannerTemplating: boolean
}

const Cashmere25ProductsHeader = ({url, enableSearchBannerTemplating}: Cashmere25ProductsHeaderProps) => {
    const searchBannerTextLoaded = useSearchBannerLoaded(url)

    return (
        <DesktopHeaderContainer>
            <>
                <ProductsTitle />
                <SearchBannerChevronContainer data-testid="plp-search-banner-chevron-container">
                    {enableSearchBannerTemplating ? (
                        <ChevronWithContext />
                    ) : (
                        <FadeInAnimation timeout={300} show={searchBannerTextLoaded}>
                            <SearchBannerChevron />
                        </FadeInAnimation>
                    )}
                </SearchBannerChevronContainer>
            </>
        </DesktopHeaderContainer>
    )
}

export default Cashmere25ProductsHeader
